import * as React from 'react'

import { Box, Divider, List, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { InboxRequest } from 'modules/notifications/hooks/useNotificationsRequests'
import { requestCount } from 'modules/notifications/lib/RequestsCount'

interface Props {
  requests: InboxRequest[]
}

const ResumeBox = ({ requests }: Props) => {
  const { overdueCounter, dueTodayCounter } = requestCount(requests)

  return (
    <List>
      <Box padding="s24" gap="s16" width="s360">
        <Text size="400" weight="semibold" color="grey1000">
          {i18n.t('dashboard.requests.active_requests')}
        </Text>

        {!!requests.length && (
          <Text size="500" weight="medium" color="grey1000">
            {requests.length}
          </Text>
        )}

        {!requests.length && (
          <Text.Normal>{i18n.t('dashboard.requests.list.blank.title')}</Text.Normal>
        )}
      </Box>

      {!!overdueCounter && (
        <Box flexDirection="row" justifyContent="spaceBetween" paddingX="s24" paddingBottom="s16">
          <Text.Normal size="200" color="radicalRed1200" weight="medium">
            {i18n.t('dashboard.todo.due_date.overdue')}
          </Text.Normal>
          <Text.Normal size="200" color="radicalRed1200" weight="medium">
            {overdueCounter}
          </Text.Normal>
        </Box>
      )}

      {!!overdueCounter && !!dueTodayCounter && <Divider />}

      {!!dueTodayCounter && (
        <Box flexDirection="row" justifyContent="spaceBetween" paddingX="s24" paddingY="s16">
          <Text.Normal size="200" weight="medium">
            {i18n.t('dashboard.todo.due_date.today')}
          </Text.Normal>
          <Text.Normal size="200" weight="medium">
            {dueTodayCounter}
          </Text.Normal>
        </Box>
      )}
    </List>
  )
}

export default observer(ResumeBox)
